export type NSStatus = "INIT" | "LOADING" | "SUCCESS" | "ERROR";

export default class NS {
  constructor(
    public status: NSStatus,
    readonly message = "",
    readonly statusCode = 0,
    readonly responseTime = 0,
    readonly requestEndTime = 0,
    readonly requestId = "",
    readonly cached = false,
    readonly hasData = false
  ) {}

  get isInit() {
    return this.status === "INIT";
  }

  get isLoading() {
    return this.status === "LOADING";
  }

  get isError() {
    return this.status === "ERROR";
  }

  get isSuccess() {
    return this.status === "SUCCESS";
  }

  toString() {
    return this.status;
  }
}
